<template>
    <ui-modal :id="id" 
        v-model="displayModal" 
        @shownModal="reviewModalAsBodyHandler">
        
        <template #header>
            {{ 'site-map' | staticTitle }}
        </template>

        <pre class="mermaidLoader">{{ 'site-map' | staticContent }}</pre>

    </ui-modal>
</template>

<script>
/* eslint-disable */
import uiModal from './ui-modal.vue'
export default {
    components: {
        uiModal
    },
    name: 'SiteMapModal',
    props: {
        id: {
            type: String,
            default: 'site-map-modal'
        }
    },
    data: () => {
        return {
            displayModal: false
        }
    },
    methods: {
        async reviewModalAsBodyHandler() {
			console.log('reviewModalAsBodyHandler', this.displayModal)
			setTimeout(async () => {
				console.log('mermaid.run', window.mermaid)
				await window.mermaid.run({
					querySelector: '.mermaidLoader',
				});
			}, 100);
		},
        display() {
            this.displayModal = true;
        }
    }
}
</script>